// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_moment_dist_index_js-node_modules_leaflet-defaulticon-compatib-1c7d79":"618204cece32605b64f3","node_modules_moment_locale_sync_recursive_-src_views_PhotosTab_vue":"85f72d0833d0b6cd7ae7"}[chunkId] + "";
};